import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "au-view" };
const _hoisted_2 = ["innerHTML"];
import DOMPurify from "dompurify";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UMarkdownViewer',
    props: {
        content: {}
    },
    setup(__props) {
        const props = __props;
        const compiledMarkdown = computed(() => {
            if (!props.content) {
                return "";
            }
            // Защита от XSS
            let html = DOMPurify.sanitize(props.content);
            // Обработка строк построчно
            let lines = html.split("\n");
            let result = [];
            lines.forEach(line => {
                // Обработка цитат (>)
                if (line.trim().startsWith("&gt;")) {
                    const content = line.replace(/^&gt;\s*/, "");
                    result.push(`<div class="au-blockquote">${content}</div>`);
                }
                // Обработка списков (-)
                else if (line.trim().startsWith("- ")) {
                    result.push(line.replace(/^- (.*)/, "<li>$1</li>"));
                }
                else if (line.trim().startsWith("### ")) {
                    result.push(line.replace(/### (.*)/, "<h3>$1</h3>"));
                }
                else if (line.trim().startsWith("## ")) {
                    result.push(line.replace(/## (.*)/, "<h2>$1</h2>"));
                }
                else if (line.trim().startsWith("# ")) {
                    result.push(line.replace(/# (.*)/, "<h1>$1</h1>"));
                }
                // Обычный текст
                else {
                    result.push(`<div>${line}</div>`);
                }
            });
            // Собираем обратно
            // html = result.join("<br>");
            html = result.join("");
            // Обработка форматирования в тексте
            html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
            html = html.replace(/_([^_]+)_/g, "<em>$1</em>");
            // Обработка списков (оборачиваем в ul)
            html = html.replace(/(<li>.*?<\/li>)+/g, matches => `<ul>${matches}</ul>`);
            return html;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", { innerHTML: compiledMarkdown.value }, null, 8, _hoisted_2)
            ]));
        };
    }
});
